import styled from 'styled-components';

export const FormLine = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-end;
  width: 100%;
  gap: 16px;
  flex: 1;
  & > div {
    width: 100%;
  }

  .ant-form-item-control,
  .ant-form-item-row {
    width: 100%;
  }

  .ant-form-item {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .ant-form-item-explain-error {
    word-break: break-word;
    white-space: normal;
    max-width: 100%;
    overflow-wrap: break-word;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  width: 100%;
  gap: 0 16px;

  .ant-form-item-control,
  .ant-form-item-row {
    width: 100%;
  }

  .ant-form-item {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .ant-form-item-explain-error {
    word-break: break-word;
    white-space: normal;
    max-width: 100%;
    overflow-wrap: break-word;
  }

  .fullColumn {
    grid-column: 1/-1;
  }
`;
